module.exports = __webpack_public_path__ + "img/jisushenhe.56188224.png";